/**
 * 311即时订货查询模块接口列表
 */
import Vue from "vue"
import axios from '@/utils/http'; // 导入http中创建的axios实例
const delivery = {
    //页面初始化
    init() {
        return axios.get(`${Vue.prototype.$base.API_PATH}/delivery/init`);
    },
    //得到进退货查询数据集合
    list(params) {
        return axios.get(`${Vue.prototype.$base.API_PATH}/delivery/list`, { params: params});
    },
    //得到进退货查询明细数据集合
    data(params) {
        return axios.get(`${Vue.prototype.$base.API_PATH}/delivery/data`, { params: params});
    },
}

export default delivery;



// WEBPACK FOOTER //
// ./src/api/delivery.js